module.exports = __webpack_public_path__ + "img/能源效率管理.d738243c.png";